import { useSelector } from 'react-redux';
import { getCatalogSettings } from 'b2b-apps/shop/settings/redux/selectors';
import {
  PageSizeSettingType,
  SortingSettingType,
  ViewTypeSettingType,
} from 'b2b-apps/shop/settings/redux/types';

type UseCatalogSettingsDataReturnType = {
  viewType: ViewTypeSettingType;
  pageSize: PageSizeSettingType;
  sorting: SortingSettingType;
};

const useCatalogSettingsData = (): UseCatalogSettingsDataReturnType => {
  const catalogSettings = useSelector(getCatalogSettings);

  return {
    viewType: catalogSettings.viewType,
    pageSize: catalogSettings.pageSize,
    sorting: catalogSettings.sorting,
  };
};

export type { UseCatalogSettingsDataReturnType };
export { useCatalogSettingsData };
